module.exports = __webpack_public_path__ + "img/icon_white_parking-P.a5a8cd68.svg";